import { PreloaderHelper } from "shared/helpers";
import { Tutorial } from "shared/services/tutorials/tutorial";
import { Localizer } from "shared/localization";
import { SoundService } from "shared/services/sound.service";
import { LanguageService, TutorailNameSerivce } from "..";
import { BuildConfig } from "shared/config";
import config from "config";

export class BackgroundReleaseTutorial {

    public static toggleBackgroundReleaseTutorial(state: boolean, screen: PIXI.Container): void {
        const prefixes = BuildConfig.getConfig();
        const slides = [
            {
                //@ts-ignore
                img: `${subPath}assets/gif/tut_bg_release.gif`,
                text: LanguageService.getTranslation('loc_bg_release_tutorial_1')
            },
            {
                //@ts-ignore
                img: `${subPath}assets/gif/tut_bg_release.gif`,
                text: LanguageService.getTranslation('loc_bg_release_tutorial_2')
            }
        ]
        const user = JSON.parse(localStorage.getItem('mbny_game_user'));
        const tutorial = document.getElementById('tutorial');
        const closeTutorial = document.getElementById('closeTutorial');
        const startBtn = document.getElementById('startLevel');

        if (!state) {
            screen.visible = true;
            PreloaderHelper.togglePreloader(false);
            tutorial.style.display = 'none';
            return;
        }

        if (user && user.tutorails.background_release) {
            SoundService.toggleBgIntro(true, 0.5, true);
            PreloaderHelper.togglePreloader(false);
            screen.visible = true;
            tutorial.style.display = 'none';
        } else {
            document.getElementById('slider_nav').style.display = 'flex';
            Tutorial.addContent(slides, screen)
            screen.visible = false;
            tutorial.style.display = 'flex';
            TutorailNameSerivce.changeName('backgroundRelease');
            closeTutorial.addEventListener('click', () => {
                SoundService.toggleBgIntro(true, 0.5, true);
                const user = JSON.parse(localStorage.getItem('mbny_game_user'));
                user.tutorails.background_release = true;
                localStorage.setItem('mbny_game_user', JSON.stringify(user))
                tutorial.style.display = 'none';
                Tutorial.deleteNodes();
                PreloaderHelper.togglePreloader(false);
                screen.visible = true;
                if(!config.guest)Tutorial.saveTutorial(user.tutorails);
            })

            startBtn.addEventListener('click', () => {
                SoundService.toggleBgIntro(true, 0.5, true);
                const user = JSON.parse(localStorage.getItem('mbny_game_user'));
                user.tutorails.background_release = true;
                localStorage.setItem('mbny_game_user', JSON.stringify(user));
                Tutorial.deleteNodes();
                tutorial.style.display = 'none';
                PreloaderHelper.togglePreloader(false);
                screen.visible = true;
                if(!config.guest)Tutorial.saveTutorial(user.tutorails);
            })
        }
    }
}